import { render, staticRenderFns } from "./StepperPasoCuatro.vue?vue&type=template&id=38524526"
import script from "./StepperPasoCuatro.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperPasoCuatro.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports